import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { localizePath } from '../i18n/paths';

/**
 * Drop-in replacement for <Link to="/...">, automatically translating
 * internal IT paths to the EN equivalent when the current language is English.
 */
const LocalizedLink = ({ to, children, ...rest }) => {
  const { i18n } = useTranslation();
  const lang = (i18n.language || 'it').split('-')[0];
  const target = typeof to === 'string' ? localizePath(to, lang) : to;
  return (
    <Link to={target} {...rest}>
      {children}
    </Link>
  );
};

export default LocalizedLink;
